/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=11e9579a&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=11e9579a&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/test-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e9579a"]])

export default __exports__